import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { genAiStrategyCopy } from '@/contexts/language/translations/pages/genAiStrategy';

const TALK_TO_YOUR_DATA_IMAGE = '/lovable-uploads/talk_to_your_data_pic.png';

// Titles and descriptions live in translations/pages/genAiStrategy.ts (same order as this array).
const TABS = [
  {
    id: 'context-aware',
    image: TALK_TO_YOUR_DATA_IMAGE,
  },
  {
    id: 'actionable',
    image: '/lovable-uploads/retail-ai-dataset.png',
  },
  {
    id: 'chatbot',
    image: TALK_TO_YOUR_DATA_IMAGE,
  },
  {
    id: 'mcp',
    image: TALK_TO_YOUR_DATA_IMAGE,
  },
];

const GenAIStrategySection = () => {
  const { language } = useLanguage();
  const c = genAiStrategyCopy[language];
  const tabs = TABS.map((tab, i) => ({ ...tab, ...c.tabs[i] }));
  const [activeId, setActiveId] = useState(TABS[0].id);
  const activeTab = tabs.find((t) => t.id === activeId) ?? tabs[0];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3">
          {c.headingPrefix}{' '}
          <span className="text-[#FF6B35]">{c.headingAccent}</span>
        </h2>
        <p className="text-muted-foreground text-center text-lg max-w-2xl mx-auto mb-12">
          {c.subtitle}
        </p>

        <div
          className="rounded-2xl border-2 p-4 md:p-6"
          style={{ borderColor: '#b7b7b7' }}
        >
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveId(tab.id)}
                className={cn(
                  'text-left p-5 rounded-lg border transition-all duration-200 flex flex-col',
                  activeId === tab.id
                    ? 'bg-foreground/8 border-foreground/15 shadow-sm'
                    : 'bg-muted/40 border-transparent hover:bg-muted/60'
                )}
              >
                <h3
                  className={cn(
                    'font-semibold text-base mb-2 min-h-[2.75rem] flex items-start',
                    activeId === tab.id ? 'text-foreground' : 'text-gray-500'
                  )}
                >
                  {tab.title}
                </h3>
                <p
                  className={cn(
                    'text-sm leading-relaxed',
                    activeId === tab.id ? 'text-foreground' : 'text-gray-400'
                  )}
                >
                  {tab.description}
                </p>
              </button>
            ))}
          </div>

          <div className="flex justify-center px-4 pb-4 pt-2">
            <div
              key={activeId}
              className="rounded-xl overflow-hidden border border-border bg-muted/20 w-full max-w-2xl animate-slide-up-from-bottom"
            >
              <img
                src={activeTab.image}
                alt={activeTab.title}
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GenAIStrategySection;
